<template>
    <SmoothLoader tag="section" class="post-filters grid gap-2 max-w-4xl mx-auto pt-4 mb-16">
        <h3 class="text-center text-3xl font-headline font-bold text-primary-700 mb-4">Filter By:</h3>

        <div class="">
            <div class="styled-select w-full">
                <label for="filter-topic" class="sr-only">Select a Topic</label>
                <select v-model="selections.topic" id="filter-topic" class="">
                    <option :selected="!results.topic" :value="null">Topics</option>
                    <option v-for="topic in filters.topics" :value="topic.id" :selected="results.topic && results.topic === topic.id">{{ topic.name }}</option>
                </select>
            </div>
        </div>
        <div class="">
            <div class="styled-select w-full">
                <label for="filter-tag" class="sr-only">Select a Tag</label>
                <select v-model="selections.tag" id="filter-tag" class="">
                    <option :selected="!results.tag" :value="null">Tags</option>
                    <option v-for="tag in filters.tags" :value="tag.id" :selected="results.tag && results.tag === topic.id">{{ tag.name }}</option>
                </select>
            </div>
        </div>
        <div class="">
            <button @click.prevent="emitSelections" class="filter-button w-full text-white font-headline font-bold bg-primary-700 rounded-md text-3xl transition-colors hover:bg-secondary-600 focus:bg-secondary-600">Filter</button>
        </div>

    </SmoothLoader>
</template>

<script>
import { ref } from 'vue';

export default {

    emits: ['selection'],
    
    props: ['results', 'filters'],

    setup(props, {emit}) {

        const selections = ref({
            topic: props.results.topic,
            tag: props.results.tag
        });

        const emitSelections = () => {
            emit('selection', selections.value);
        };

        return {
            emitSelections,
            selections
        }

    }

}
</script>